export const examAdminReview = {
  pageTitle: "採点センター",
  pageSubtitle: "AI 事前採点 + 手動最終採点。まず記述問題の採点フローを収束します。",
  summary: {
    pending: "採点待ち項目：{count}",
    shortAnswer: "記述問題：{count}",
    aiReviewed: "AI 事前採点済み：{count}",
  },
  actions: {
    aiReviewShortAnswer: "記述問題を AI 事前採点",
    goReview: "採点へ",
    submitScore: "採点を送信",
  },
  messages: {
    scoreSubmitted: "採点スコアを送信しました",
    aiReviewCompleted: "AI 事前採点が完了しました：成功 {success}、失敗 {failed}",
  },
  notices: {
    aiReviewHint:
      "AI 事前採点は推奨点のみを生成し、最終的な主観点にはなりません。manual/review を送信してから収束します。",
  },
  drawers: {
    manualReviewTitle: "手動採点",
    manualReviewTitleWithId: "手動採点 #{id}",
  },
  fields: {
    score: "得点",
    comment: "コメント",
    commentPlaceholder: "採点説明または得点根拠を入力",
    detailJson: "detail_json",
  },
  labels: {
    notReviewed: "未事前採点",
    stem: "問題文",
    aiSummary: "AI 事前採点サマリー",
    suggestedScore: "推奨点：{score}",
    context: "コンテキスト",
    aiHits: "AI ヒット点",
  },
  table: {
    attemptQuestion: "Attempt Question",
    examId: "試験 ID",
    questionId: "問題 ID",
    questionType: "問題タイプ",
    title: "タイトル",
    aiReview: "AI 事前採点",
    actions: "操作",
  },
} as const;
